import Cancel from '@mui/icons-material/Cancel'
import { Stack, Typography } from '@mui/material'
import useGetThemeColor from '@/hooks/useGetThemeColor'

export type Tag = { name: string; color: string; id?: string }
type TagChipProps = {
  tag?: Tag
  invisible?: boolean
  onDelete?: (tag: Tag) => void
}

export default function TagChip({
  tag,
  invisible = false,
  onDelete,
}: TagChipProps) {
  const getThemeColor = useGetThemeColor()
  return tag ? (
    <Stack
      alignItems="center"
      direction="row"
      spacing={0.5}
      sx={{
        p: 0.25,
        px: 0.5,
        background: getThemeColor(tag.color),
        fontSize: 10,
        borderRadius: 1,
        height: 'fit-content',
        fontWeight: 'bold',
        textWrap: 'nowrap',
        visibility: invisible ? 'hidden' : 'visible',
        color: 'white',
        maxWidth: '100%',
        minWidth: 0,
      }}
    >
      <Typography
        variant="inherit"
        component="p"
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {tag.name}
      </Typography>

      {onDelete && (
        <Cancel
          onClick={() => onDelete(tag)}
          fontSize="inherit"
          sx={{
            flexShrink: 0,
            fontSize: '14px',
            color: 'white',
            cursor: 'pointer',
            ':hover': { color: '#ffffffcc' },
          }}
        />
      )}
    </Stack>
  ) : null
}
